module.exports = __webpack_public_path__ + "media/mem_sale.dfb1b1f9.mp4";